import getAPIResponse from "Shared/Utils/Domain/Services/GetAPIResponsePrivateService";

export async function deleteScheduledCommand(id) {
	return await getAPIResponse("/command-scheduler/scheduled-command/"+id, {}, "DELETE");
}